import { NavLink, Outlet } from "react-router";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BarChartIcon from "@mui/icons-material/BarChart";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

/**
 * @returns Configuration array defining sidebar navigation items with icon, label, and route path
 */
const navItems = [
  { icon: DashboardIcon, label: "Dashboard", path: "dashboard" },
  { icon: BarChartIcon, label: "Reports", path: "reports" },
  { icon: QueryStatsIcon, label: "Analytics", path: "Analytics" },
  { icon: RequestQuoteIcon, label: "Weekly Report", path: "weekly-cost-report" },
];

/**
 * @returns Layout component rendering sidebar navigation and route content via Outlet
 */
const CostDashboard = () => {
  return (
    <div className="flex bg-[var(--bg-canvas)] h-full min-h-0">
    
        <div className="w-16 bg-[var(--bg-sidebar)] flex flex-col items-center pt-4 border-r border-[var(--border-subtle)]">
          <div className="flex flex-col items-center gap-6 w-full">
            {navItems.map(({ icon: Icon, label, path }) => (
              <NavLink
                key={path}
                to={path}
                className={({ isActive }) =>
                  `w-full flex flex-col items-center justify-center py-2 cursor-pointer border-l-[3px] transition-colors
                   ${isActive ? "border-l-[var(--nav-active-indicator)] bg-[var(--nav-active-bg)]" : "border-l-[var(--border-transparent)] hover:bg-[var(--nav-hover-bg)]"}`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon sx={{ fontSize: 23 }} style={{ color: isActive ? "var(--text-primary)" : "var(--widget-icon)" }} />
                    <span className="text-[10px] font-medium leading-tight mt-1 text-center break-words" style={{ color: isActive ? "var(--text-primary)" : "var(--nav-text-default)" }}>
                      {label}
                    </span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      

      <div className="flex-1 min-h-0 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};

export default CostDashboard;
